import { render } from "./TaxonomyPill.vue?vue&type=template&id=6beb7667"
import script from "./TaxonomyPill.vue?vue&type=script&lang=js"
export * from "./TaxonomyPill.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__